import React from 'react';
import PropTypes from 'prop-types';
import { flowRight as compose } from 'lodash';
import withStyles from 'isomorphic-style-loader/withStyles';

import Inbox from '../../components/Inbox';
import AllThreadsQuery from './AllThreadsQuery.graphql';

import s from './Inbox.css';
import { withQuery } from '../../hoc/withGraphql';
const InboxContainer = ({ allThreads }) => {

  return (
    <>
      <Inbox allThreads={allThreads} />
    </>
  );
}

InboxContainer.propTypes = {
  title: PropTypes.string.isRequired,
  allThreads: PropTypes.object
};

export default compose(
  withStyles(s),
  withQuery(AllThreadsQuery, {
    name: 'allThreads',
    options: {
      variables: {
        currentPage: 1
      },
      ssr: false,
      fetchPolicy: 'network-only',
    }
  }),
)(InboxContainer);
